/**
 * 数据请求判断是否代理服务
 */
const Request =
{
  /**
     * 数据请求
     */
  getPost(param)
  {
    // let service = 'AreaSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'AreaSvr'
    else if (Ip === '192.168.2.218')
      service = 'AreaSvr'
    else if (Ip === '113.12.121.21')
      service = 'AreaSvr'
    else if (Ip === '10.7.64.82')
      service = 'AreaSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/AreaSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/AreaSvr'
    else
      service = 'svr/AreaSvr'
    return cx.http.post(service, param)
  },
  getLogin(param)
  {
    // let service = 'LoginSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'LoginSvr'
    else if (Ip === '192.168.2.218')
      service = 'LoginSvr'
    else if (Ip === '192.168.2.65')
      service = 'LoginSvr'
    else if (Ip === '113.12.121.21')
      service = 'LoginSvr'
    else if (Ip === '10.7.64.82')
      service = 'LoginSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/LoginSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/LoginSvr'
    else
      service = 'svr/LoginSvr'
    return cx.http.post(service, param)
  },
  getZLKSum(param)
  {
    // let service = 'PrjSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'PrjSvr'
    else if (Ip === '192.168.2.218')
      service = 'PrjSvr'
    else if (Ip === '113.12.121.21')
      service = 'PrjSvr'
    else if (Ip === '10.7.64.82')
      service = 'PrjSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/PrjSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/PrjSvr'
    else
      service = 'svr/PrjSvr'
    return cx.http.post(service, param)
  },
  getIdentitySvr(param)
  {
    // let service = 'IdentitySvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'IdentitySvr'
    else if (Ip === '192.168.2.218')
      service = 'IdentitySvr'
    else if (Ip === '113.12.121.21')
      service = 'IdentitySvr'
    else if (Ip === '10.7.64.82')
      service = 'IdentitySvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/IdentitySvr'
    else if (Ip === 'camining.cn')
      service = 'svr/IdentitySvr'
    else
      service = 'svr/IdentitySvr'
    return cx.http.post(service, param)
  },
  getLoginSvr(param)
  {
    // let service = 'LoginSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'LoginSvr'
    else if (Ip === '192.168.2.218')
      service = 'LoginSvr'
    else if (Ip === '113.12.121.21')
      service = 'LoginSvr'
    else if (Ip === '10.7.64.82')
      service = 'LoginSvr'
    else if (Ip === '192.168.2.44')
      service = 'LoginSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/LoginSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/LoginSvr'
    else
      service = 'svr/LoginSvr'
    return cx.http.post(service, param)
  },
  getFileSvr(param)
  {
    // let service = 'FileSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'FileSvr'
    else if (Ip === '192.168.2.218')
      service = 'FileSvr'
    else if (Ip === '113.12.121.21')
      service = 'FileSvr'
    else if (Ip === '10.7.64.82')
      service = 'FileSvr'
    else if (Ip === '192.168.2.44')
      service = 'FileSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/FileSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/FileSvr'
    else
      service = 'svr/FileSvr'
    return cx.http.post(service, param)
  },
  getTDTSvr(param)
  {
    let service = 'SecretSvr'
    return cx.http.get(service, param)
  },
  getDocSvr(param)
  {
    let service = 'DocSvr'
    return cx.http.post(service, param)
  },
  getSendEmail(param)
  {
    // let service = 'MailSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'MailSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/MailSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/MailSvr'
    else
      service = 'svr/MailSvr'
    return cx.http.post(service, param)
  },
  getDmSvr(param)
  {
    // let service = 'DmSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'DmSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/DmSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/DmSvr'
    else
      service = 'svr/DmSvr'
    return cx.http.post(service, param)
  },
  getDocGetSvr(param)
  {
    // let service = 'DocGetSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'DocGetSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/DocGetSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/DocGetSvr'
    else
      service = 'svr/DocGetSvr'
    return cx.http.post(service, param)
  },
  getReportSvr(param)
  {
    // let service = 'DocGetSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'ReportSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/ReportSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/ReportSvr'
    else
      service = 'svr/ReportSvr'
    return cx.http.post(service, param)
  },
  getReportGetSvr(param)
  {
    // let service = 'DocGetSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'ReportGetSvr'
    else if (Ip === 'www.camining.cn')
      service = 'svr/ReportGetSvr'
    else if (Ip === 'camining.cn')
      service = 'svr/ReportGetSvr'
    else
      service = 'svr/ReportGetSvr'
    return cx.http.get(service, param)
  },
  // 新版短信发送接口
  getSendSmsSvr(param)
  {
    // let service = 'DocGetSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'zgis/massvr/sendSms'
    else if (Ip === 'www.camining.cn')
      service = 'svr/zgis/massvr/sendSms'
    else if (Ip === 'camining.cn')
      service = 'svr/zgis/massvr/sendSms'
    else
      service = 'svr/zgis/massvr/sendSms'
    param.headers = {'Content-Type': 'application/json'}
    return cx.http.post(service, param)
  },

  // 新版短信验证接口
  getVerifySmsSvr(param)
  {
    // let service = 'DocGetSvr'
    let Ip = window.location.hostname
    let service = null
    if (Ip === '192.168.2.201')
      service = 'zgis/massvr/verifySms'
    else if (Ip === 'www.camining.cn')
      service = 'svr/zgis/massvr/verifySms'
    else if (Ip === 'camining.cn')
      service = 'svr/zgis/massvr/verifySms'
    else
      service = 'svr/zgis/massvr/verifySms'
    return cx.http.post(service, param)
  }
}
export default Request



// WEBPACK FOOTER //
// ./src/plugins/app/method/getpost.js